
import lang from 'element-ui/lib/locale/lang/ar' // 引入element语言包
const messages = {
  "极兔开放平台": "منصة J & T Express المفتوحة",
  帮助中心:"مركز المساعدة",
  indexPage:{
    title:"منصة إرساء تكنولوجيا خدمة البريد السريع",
    BannerTxt:"مشاركة واجهات الخدمة المختلفة لـ J & T ، وتحقيق تكامل سلسلة التوريد اللوجستية ، ومساعدة المؤسسات على إكمال التسليم السريع بكفاءة ، وتتبع المعلومات ، وتقديم خدمات ذات قيمة مضافة لأمن المعلومات السريع. تحقيق التعاون الفعال مع J&T.",
    BannerBtnTxt:"انضم إلى منصة J&T المفتوحة",
  },

  helpCenter:{
    "常用工具":"أدوات مشتركة",
    签名工具: "أداة التوقيع",
    电子面单模板: "قالب ورقة الوجه الإلكترونية",
    "API-SDK说明": "وصف API-SDK",
    签名方式:"طريقة التوقيع",
    method_1:"1. استخدم طريقة تقديم نموذج بروتوكول http للتفاعل مع المعلومات ، ويتم توحيد ترميز الأحرف بواسطة UTF-8 افتراضيًا ، وتنسيق البيانات: application / x-www-form-urlencoded؛",
    method_2:"2. يتم توفير apiAccount و privateKey من خلال النظام الأساسي ؛ Digg = base64 (md5 (Json + privateKey of business parameters)) ، ملاحظة: يحصل md5 أولاً على مصفوفة البايت ، ثم تشفير base64 ؛",
    method_3:`3. على سبيل المثال: base64 (MD5 ({"age": 18، "gender": "male"، "name": "zhangsan"} 123456)) إذا كان التوقيع خاطئًا ، يمكنك تشفير عنوان URL وإرسال الطلب .`,
    method_4:"4. اصطلاح نوع الحقل: يجب أن يتم التطوير في توافق صارم مع تنسيق وحجم المعلمات الوارد في جدول الحقل.",
    method_5:"5. اصطلاحات تحليل المجال: الحقول المطلوبة في حقول المعلمات مطلوبة لتمريرها في كل مرة يتم فيها استدعاء الواجهة ؛",
    method_6:"6. للحصول على جزء من نموذج التعليمات البرمجية للواجهة و SDK ، يرجى الرجوع إلى نموذج التعليمات البرمجية ووثائق SDK.",
    业务参数签名:"توقيع المعلمة الأعمال",
    请输入加密后的32位pwd:"الرجاء إدخال مشفرة الأشخاص ذوي الإعاقة 32 بت",
    获取:"يحصل",
    Headers签名:"توقيع الرؤوس",
    bussness:"مثال: عند استدعاء واجهة تقديم طلب ، وإلغاء أمر ، وما إلى ذلك ، يلزم استخدام معلمة الأعمال <code>digest</code> ، ويكون لمعامل الأعمال <code>digest</code> معنى مختلف عن <code>digest</code> في Headers العام.",
    bussness_1:`بادئ ذي بدء ، ستقوم Jitu بتعيين حساب وكلمة مرور مطلوبين من قبل عميل الاتفاقية لتقديم طلب. على سبيل المثال: <code> J0086474299 </code> / <code> H5CD3zE6 </code> ، حيث <code> pwd </code> يساوي <code> MD5 (كلمة مرور النص العادي (H5CD3zE6) + jadada236t2) </ code >
    بعد الكتابة بالأحرف الكبيرة ، على سبيل المثال ، فإن 32 بت <code> pwd </code> الذي تم إنشاؤه بواسطة هذا المثال هو <code> 6A272C3DD1F3CD2F92BF567C37040910 </code> ، وأخيراً يتم إنشاء توقيع معلمة الأعمال وفقًا للقاعدة Base64 (Md5 (رقم العميل + تشفير النص + مفتاح خاص)).`,
    bussness_2:`هذا هو: توقيع معلمة الأعمال <code> Digest </code> = Base64 (Md5 (<code> J0086474299 </code> + <code> 6A272C3DD1F3CD2F92BF567C37040910 </code> + privateKey))`,
    headers_1:`مثال: خذ إلغاء طلب كمثال: افترض أن معلمة الأعمال هي bizContent كـ <code> {"customerCode": "J0086474299" ، "Digest": "U40e5sumorgd3YgZzU" ، "txlogisticId": "10000000001299" ، "السبب": "YL1234567890123"} </code> ، فإن ملخص التوقيع في الرأس في هذا الوقت يساوي <code> base64 (md5 (Json + privateKey of business parameters)) </code> ،`,
    headers_2:`وهذا يعني ، <code> base64 (md5 ({"customerCode": "J0086474299"، "Digg": "U40e5sumorgd3YgZzU"، "txlogisticId": "10000000001299"، "reason": "YL1234567890123"} + privateKey)) </ code >.`,
    headers_3:`ملاحظة: يتم تعيين <code> privateKey </code> تلقائيًا بعد مصادقة النظام الأساسي للحساب`,
    一联模版:"قالب من صفحة واحدة",
    "API开放平台-SDK":"افتح منصة API-SDK",
    "Introduction":"1 المقدمة",
    "sdk_two":"2. سجل تحديث الإصدار",
    "sdk_3_title":"3. البدء السريع بتثبيت API Open Platform SDK",
    "sdk_4_title":"4. هيكل دليل API-SDK",
    "sdk_5_title":"5 ، حزمة JAR مباشرة الخطوات التالية:",
    "sdk_6_title":"6. تبعيات المخضرمين SDK ذات الصلة",
    "sdk_7_title":"7. قم بإنشاء JtExpressApi",
    "sdk_8_title":"8. اقتراح",
    "Introduction_1":"مرحبا، مرحبا، ومرحبا بكم في استخدام API منصة مفتوحة.",
    "Introduction_2":"يستهدف هذا المستند بشكل أساسي مطوري النظام الأساسي ويصف المحتوى الفني ذي الصلة لمنصة الإرساء لتكنولوجيا الخدمة السريعة. إذا كان لديك أي أسئلة حول محتوى المستند ، يمكنك الاتصال بتشغيل النظام الأساسي للإجابة على السؤال.",
    date:"تاريخ",
    sdkVersion:"رقم النسخة",
    updata:"تحديث المحتوى",
    updataInfo:"يوفر معيارًا عامًا لاستدعاء واجهة النظام الأساسي المفتوحة ، ويساعد في إكمال توقيع الواجهة",
    "语言":"لغة",
    最新版本:"أحدث إصدار من",
    项目示例:"مثال على المشروع",
    开发环境:"بيئة التطوير",
    "支持JAVA版本":"دعم إصدار JAVA: 1.8+",
    "支持PHP":"دعم PHP7.0 وما فوق",
    签名相关类:"Signature related classes",
    公用类:"Public class",
    异常相关类:"Exception related class",
    Http通信相关类:"Http communication related classes",
    开放平台api通用接口:"Open platform api general interface",
    执行器接口:"Actuator interface",
    sdk_5_txt:`<p> 1. يتم توفير مجموعة أدوات ضغط SDK بواسطة النظام الأساسي المفتوح. </p>
    <p> 2. قم بفك ضغط "jt-openapi-sdk.zip" المقدم بواسطة النظام الأساسي المفتوح وانسخه إلى مجلد المشروع. </p>
    <p> 3. انقر فوق ملف -> هيكل المشروع (مفتاح الاختصار Ctrl + Alt + Shift + s) ، انقر فوق "الوحدات النمطية على الجانب الأيسر من واجهة هيكل المشروع. </ p>
    <p> 4. في واجهة علامة التبويب "التبعيات" ، انقر فوق علامة "+" على اليمين ، وحدد الخيار الأول "JARs أو الدلائل ..." ، وحدد حزمة الجرة المقابلة ، وانقر على "موافق" ، حزمة الجرة تم اضافته بنجاح. </p>
    <p> 5. يمكن تنزيل طريقة استدعاء SDK للواجهة المحددة كمرجع. </p>`,
    sdk_6_txt:"تستخدم SDK حزمة slf4j-api لإخراج السجل افتراضيًا ؛ تستخدم SDK fastjson لتحويل بيانات json افتراضيًا ؛ تستخدم SDK httpclient لنقل بيانات http افتراضيًا.",
    sdk_7_txt:`<p> JtExpressApi هو المنفذ العام لواجهة برمجة تطبيقات النظام الأساسي المفتوح J&T ، والذي يوفر سلسلة من الأساليب التفاعلية للمطورين الذين يستخدمون النظام الأساسي المفتوح J&T. </p>
    <p> يمكن للمستخدمين الرجوع إلى الكود التالي لإنشاء JtExpressApi جديد. بعد اكتمال التهيئة ، يوصى باستخدام مفرد لتجنب الإنشاء المتكرر: </ p>`,
    sdk_8_txt:`<p> إذا كنت تستخدم إطار عمل springboot لاستدعاء واجهات ذات صلة بـ API open platform-SDK ، فمن المستحسن وضع JtExpressApi في حاوية الربيع للإدارة ، </ p>
    <p> يمكن للمستخدمين الرجوع إلى الكود التالي لإنشاء فئة تكوين جديدة: </ p>`,




  },
  controlPage:{
    "审核状态":"حالة مراجعة",
  },
  message: {
  },
  ...lang,
}

export default messages
